import { render, staticRenderFns } from "./AudioCard.vue?vue&type=template&id=5140bc2a&scoped=true&"
import script from "./AudioCard.vue?vue&type=script&lang=js&"
export * from "./AudioCard.vue?vue&type=script&lang=js&"
import style0 from "./AudioCard.vue?vue&type=style&index=0&id=5140bc2a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5140bc2a",
  null
  
)

export default component.exports